<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 6.4C4 5.55992 4 5.13988 4.16349 4.81902C4.3073 4.53677 4.53677 4.3073 4.81902 4.16349C5.13988 4 5.55992 4 6.4 4H8.5V8.5H4V6.4Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11.5 4H13.6C14.4401 4 14.8602 4 15.181 4.16349C15.4632 4.3073 15.6927 4.53677 15.8365 4.81902C16 5.13988 16 5.55992 16 6.4V8.5H11.5V4Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4 11.5H8.5V16H6.4C5.55992 16 5.13988 16 4.81902 15.8365C4.53677 15.6927 4.3073 15.4632 4.16349 15.181C4 14.8602 4 14.4401 4 13.6V11.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11.5 11.5H16V13.6C16 14.4401 16 14.8602 15.8365 15.181C15.6927 15.4632 15.4632 15.6927 15.181 15.8365C14.8602 16 14.4401 16 13.6 16H11.5V11.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'DashboardIcon'
}
</script>

